import type {LDFlagSet} from 'launchdarkly-react-client-sdk';

import ldFlags from '../../ld_flags.json';

export const FLAG_DEFAULTS: LDFlagSet = Object.fromEntries(
  Object.entries(ldFlags.flagsState).map(([key, flagData]) => [key, flagData.value])
);
